import React, { useState } from 'react';
import { LogIn, Loader2 } from 'lucide-react';

const GameCodeInput = ({ onJoin, loading }) => {
  const [code, setCode] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = code.trim().toUpperCase();
    if (trimmed) {
      onJoin(trimmed);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2">
      <input
        type="text"
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        placeholder="GEO-XXXX"
        maxLength={10}
        className="flex-1 px-4 py-3 bg-slate-800 border border-slate-600 rounded-xl text-white font-mono text-center text-lg tracking-widest placeholder-slate-500 focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-400/20 uppercase"
      />
      <button
        type="submit"
        disabled={!code.trim() || loading}
        className="px-5 py-3 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-400 hover:to-purple-500 disabled:from-slate-600 disabled:to-slate-700 text-white font-bold rounded-xl transition-all disabled:cursor-not-allowed flex items-center gap-2"
      >
        {loading ? (
          <Loader2 className="w-5 h-5 animate-spin" />
        ) : (
          <LogIn className="w-5 h-5" />
        )}
        Rejoindre
      </button>
    </form>
  );
};

export default GameCodeInput;
